module.exports = __webpack_public_path__ + "static/img_1535-894415d27d7ce45bdbdc11c1125371f9.webp";